/**
 * Created by shubham on 11/4/18.
 */

/**
 * A model for an individual corporate employee
 */
export class AdminListDashboard {
    id:number;
    Name: string;
    roleName: string;
    email: string;
    emailVerified: boolean;
    userId_WPASS: string;
    pendingSubUserCount: string;
    languageId: string;
    languageName: string;
    active: boolean;
    status: string;
    createdAt: string;

    constructor(id:number, Name:string, roleName:string, email:string, emailVerified:boolean, userId_WPASS:string, pendingSubUserCount:string,
                languageId:string, languageName: string, active: boolean, status: string, createdAt: string){
        this.id = id;
        this.Name = Name;
        this.roleName = roleName;
        this.email = email;
        this.emailVerified = emailVerified;
        this.userId_WPASS = userId_WPASS;
        this.pendingSubUserCount = pendingSubUserCount;
        this.languageId = languageId;
        this.languageName = languageName;
        this.active = active;
        this.status = status;
        this.createdAt = createdAt;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/adminManagement/adminList-datatable/adminList-dashboard.ts